// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .home-body {
    font-family: "Arial", sans-serif;
    background: url(./imgs/white-bg.jpg) #f8f9fa; /* Fallback color if image is missing */
    /* background-size: cover;
    min-height: 100vh;
    position: relative;
    z-index: 1;
  }  */ 
  
/* 1️⃣ Gradient background on the home container */
.home-body {
  margin: auto;
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
  overflow: auto;
  background: linear-gradient(
    315deg,
    hwb(192 94% 2%)   3%,
    rgb(209, 212, 200) 38%,
    rgb(200, 250, 212) 68%,
    hwb(224 66% 6%)   98%
  );
  animation: gradient 15s ease infinite;
  background-size: 400% 400%;
  background-attachment: fixed;
  position: relative; /* so we can stack content above waves */
}

/* 2️⃣ Gradient animation */
@keyframes gradient {
  0%   { background-position: 0%   0%;   }
  50%  { background-position: 100% 100%; }
  100% { background-position: 0%   0%;   }
}

/* 3️⃣ Waves: fixed, full-width, infinite animation */
.wave {
  background: rgba(255, 255, 255, 0.25);
  border-radius: 1000% 1000% 0 0;
  position: fixed;
  width: 200%;
  height: 10em;
  animation: wave 10s -3s linear infinite;
  transform: translate3d(0, 0, 0);
  opacity: 0.8;
  bottom: 0;
  left: 0;
  z-index: -1; /* → behind your nav/content but above the gradient */
}

.wave:nth-of-type(2) {
  bottom: -1.25em;
  animation: wave 18s linear reverse infinite;
  opacity: 0.8;
}

.wave:nth-of-type(3) {
  bottom: -2.5em;
  animation: wave 20s -1s reverse infinite;
  opacity: 0.9;
}

/* 4️⃣ Wave keyframes */
@keyframes wave {
  2%   { transform: translateX(1);     }
  25%  { transform: translateX(-25%);  }
  50%  { transform: translateX(-50%);  }
  75%  { transform: translateX(-25%);  }
  100% { transform: translateX(1);     }
}




  .home-body{
    margin: 0px;
    height: 100vh;
  }
  
  .background-container{
    position: relative;
  }
  
  .background-1{
    position: absolute;
    opacity: 0.5;
    z-index: 1;
  }
  
  .background-2{
    position: absolute;
    opacity: 1;
    z-index: 0;
  }





  .home-body .navbar {
    background-color: #bee3ff;
  }
  
  .home-body .navbar-brand {
    font-weight: bold;
    color: #343a40 !important;
  }
  
  .home-body .nav-link {
    color: #343a40 !important;
  }
  
  .home-body .navbar-toggler-icon {
    background-color: #343a40;
  }
  
  .home-body #chat-container {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 1000;
  }
  
  .home-body .service-container {
    margin-top: 30px;
  }
  
  .home-body .card-transparent {
    background: transparent;
    border: none;
  }
  
  .home-body .service-card {
    transition: transform 0.3s ease-in-out;
  }
  
  .home-body .service-card:hover {
    transform: scale(1.5);
  }
  
  .home-body .card-img-top {
    max-height: 150px;
    width: 100%;
    object-fit: cover;
    margin-bottom: 10px;
  }
  
  .home-body .card-title {
    font-weight: bold;
  }
  
  .home-body .card-text {
    color: #6c757d;
  }
  
  .home-body .card-footer {
    background: transparent;
    border: none;
    padding: 0;
  }
  
  .home-body .btn-primary {
    background-color: #7952b3;
    border-color: #7952b3;
  }
  
  .home-body .btn-primary:hover {
    background-color: #6c42a3;
    border-color: #6c42a3;
  }
  
  /* Utility to ensure content is visible under the chat widget */
  .home-body #content {
    position: relative;
    z-index: 2;
  }`, "",{"version":3,"sources":["webpack://./src/components/Home.css"],"names":[],"mappings":"AAAA;;yFAEyF;IACrF;;;;MAIE;;AAEN,kDAAkD;AAClD;EACE,YAAY;EACZ,0DAA0D;EAC1D,cAAc;EACd;;;;;;GAMC;EACD,qCAAqC;EACrC,0BAA0B;EAC1B,4BAA4B;EAC5B,kBAAkB,EAAE,wCAAwC;AAC9D;;AAEA,2BAA2B;AAC3B;EACE,OAAO,4BAA4B,IAAI;EACvC,OAAO,8BAA8B,EAAE;EACvC,OAAO,4BAA4B,IAAI;AACzC;;AAEA,qDAAqD;AACrD;EACE,qCAAqC;EACrC,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,+BAA+B;EAC/B,YAAY;EACZ,SAAS;EACT,OAAO;EACP,WAAW,EAAE,qDAAqD;AACpE;;AAEA;EACE,eAAe;EACf,2CAA2C;EAC3C,YAAY;AACd;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,OAAO,wBAAwB,MAAM;EACrC,OAAO,2BAA2B,GAAG;EACrC,OAAO,2BAA2B,GAAG;EACrC,OAAO,2BAA2B,GAAG;EACrC,OAAO,wBAAwB,MAAM;AACvC;;;;;EAKE;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,UAAU;EACZ;;;;;;EAMA;IACE,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,WAAW;IACX,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA,+DAA+D;EAC/D;IACE,kBAAkB;IAClB,UAAU;EACZ","sourcesContent":["/* .home-body {\n    font-family: \"Arial\", sans-serif;\n    background: url(./imgs/white-bg.jpg) #f8f9fa; /* Fallback color if image is missing */\n    /* background-size: cover;\n    min-height: 100vh;\n    position: relative;\n    z-index: 1;\n  }  */ \n  \n/* 1️⃣ Gradient background on the home container */\n.home-body {\n  margin: auto;\n  font-family: -apple-system, BlinkMacSystemFont, sans-serif;\n  overflow: auto;\n  background: linear-gradient(\n    315deg,\n    hwb(192 94% 2%)   3%,\n    rgb(209, 212, 200) 38%,\n    rgb(200, 250, 212) 68%,\n    hwb(224 66% 6%)   98%\n  );\n  animation: gradient 15s ease infinite;\n  background-size: 400% 400%;\n  background-attachment: fixed;\n  position: relative; /* so we can stack content above waves */\n}\n\n/* 2️⃣ Gradient animation */\n@keyframes gradient {\n  0%   { background-position: 0%   0%;   }\n  50%  { background-position: 100% 100%; }\n  100% { background-position: 0%   0%;   }\n}\n\n/* 3️⃣ Waves: fixed, full-width, infinite animation */\n.wave {\n  background: rgba(255, 255, 255, 0.25);\n  border-radius: 1000% 1000% 0 0;\n  position: fixed;\n  width: 200%;\n  height: 10em;\n  animation: wave 10s -3s linear infinite;\n  transform: translate3d(0, 0, 0);\n  opacity: 0.8;\n  bottom: 0;\n  left: 0;\n  z-index: -1; /* → behind your nav/content but above the gradient */\n}\n\n.wave:nth-of-type(2) {\n  bottom: -1.25em;\n  animation: wave 18s linear reverse infinite;\n  opacity: 0.8;\n}\n\n.wave:nth-of-type(3) {\n  bottom: -2.5em;\n  animation: wave 20s -1s reverse infinite;\n  opacity: 0.9;\n}\n\n/* 4️⃣ Wave keyframes */\n@keyframes wave {\n  2%   { transform: translateX(1);     }\n  25%  { transform: translateX(-25%);  }\n  50%  { transform: translateX(-50%);  }\n  75%  { transform: translateX(-25%);  }\n  100% { transform: translateX(1);     }\n}\n\n\n\n\n  .home-body{\n    margin: 0px;\n    height: 100vh;\n  }\n  \n  .background-container{\n    position: relative;\n  }\n  \n  .background-1{\n    position: absolute;\n    opacity: 0.5;\n    z-index: 1;\n  }\n  \n  .background-2{\n    position: absolute;\n    opacity: 1;\n    z-index: 0;\n  }\n\n\n\n\n\n  .home-body .navbar {\n    background-color: #bee3ff;\n  }\n  \n  .home-body .navbar-brand {\n    font-weight: bold;\n    color: #343a40 !important;\n  }\n  \n  .home-body .nav-link {\n    color: #343a40 !important;\n  }\n  \n  .home-body .navbar-toggler-icon {\n    background-color: #343a40;\n  }\n  \n  .home-body #chat-container {\n    position: fixed;\n    bottom: 20px;\n    right: 20px;\n    z-index: 1000;\n  }\n  \n  .home-body .service-container {\n    margin-top: 30px;\n  }\n  \n  .home-body .card-transparent {\n    background: transparent;\n    border: none;\n  }\n  \n  .home-body .service-card {\n    transition: transform 0.3s ease-in-out;\n  }\n  \n  .home-body .service-card:hover {\n    transform: scale(1.5);\n  }\n  \n  .home-body .card-img-top {\n    max-height: 150px;\n    width: 100%;\n    object-fit: cover;\n    margin-bottom: 10px;\n  }\n  \n  .home-body .card-title {\n    font-weight: bold;\n  }\n  \n  .home-body .card-text {\n    color: #6c757d;\n  }\n  \n  .home-body .card-footer {\n    background: transparent;\n    border: none;\n    padding: 0;\n  }\n  \n  .home-body .btn-primary {\n    background-color: #7952b3;\n    border-color: #7952b3;\n  }\n  \n  .home-body .btn-primary:hover {\n    background-color: #6c42a3;\n    border-color: #6c42a3;\n  }\n  \n  /* Utility to ensure content is visible under the chat widget */\n  .home-body #content {\n    position: relative;\n    z-index: 2;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
